export default __webpack_public_path__ + "buysearchsell/images/Trades_Services_Clothes.svg";